import { getItem, removeItem, setItem } from '~/utils/localStorageHelpers';

const listenedVoiceIDsStorageKey = 'beams:voice:listenedVoiceIDs';

export const state = () => ({
    listenedIDs: new Set(JSON.parse(getItem(listenedVoiceIDsStorageKey)) || new Set()),
});

export const actions = {
    markAsListenedTo(context, { post }) {
        if (!post?.id) {
            return;
        }

        const listenedIDs = context.getters['getListenedIDs'];
        listenedIDs.add(post.id);
        context.commit('setListenedIDs', listenedIDs);
    },
};

export const mutations = {
    setListenedIDs(state, newListenedIDs) {
        setItem(listenedVoiceIDsStorageKey, JSON.stringify(Array.from(newListenedIDs)));
        state.listenedIDs = new Set(newListenedIDs);
    },
};

export const getters = {
    getListenedIDs(state) {
        return state.listenedIDs;
    },

    getDidListenTo: (state) => (postID) => {
        return state.listenedIDs.has(postID);
    },
};
